import { ApiOutlined, GlobalOutlined, LogoutOutlined, MenuOutlined, ShopOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Flex, Layout, Menu, MenuProps, Tooltip } from "antd";
import { Content, Footer, Header } from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import { createContext, useContext, useEffect, useState } from "react";
import { Auth, Role } from "../../apis/Auth";
import { AgentPage } from "../agent/AgentPage";
import { DomainPage } from "../domain/DomainPage";
import { UserPage } from "../user/UserPage";
import StopServerButton from "../task/StopServerButton";

export const MainContext = createContext({ selectedPage: "Agents" });

export function MainLayout() {

    const [collapsed, setCollapsed] = useState(false);
    const [selectedPage, setSelectedPage] = useState("Agents");
    const handleMenuClick = (e: any) => { setSelectedPage(e.key); }

    const { user, is, logout } = useContext(Auth);

    type MenuItem = Required<MenuProps>['items'][number];
    function getItem(
        label: React.ReactNode,
        key: React.Key,
        icon?: React.ReactNode,
        children?: MenuItem[],
    ): MenuItem {
        return {
            key,
            icon,
            children,
            label,
        } as MenuItem;
    }

    const items: MenuItem[] = is(Role.TECHNICIAN) && [
        getItem('Agents', 'Agents', <ShopOutlined />),
        getItem('Domains', 'Domains', <GlobalOutlined />),
        getItem('Users', 'Users', <UserOutlined />),
        getItem('Matches', 'demo', <ApiOutlined />),
    ] || [
        getItem('Agents', 'Agents', <ShopOutlined />),
        getItem('Matches', 'demo', <ApiOutlined />),
    ];

    return user ? (
        <MainContext.Provider value={{ selectedPage: selectedPage }}>
            <Layout className="h-100">
                <Sider className="mig-menu" collapsed={collapsed} collapsedWidth={60}>
                    <Layout className="h-100">
                        <Header>
                            <div className="toggleIcon">
                                <Button type="text" icon={<MenuOutlined />}
                                    onClick={() => setCollapsed(!collapsed)}
                                />
                            </div>
                            {!collapsed ? (
                                <img src="/media/migglo.svg" className="logo" alt="migglo" />
                            ) : null}
                        </Header>
                        <Content>
                            <Menu theme="dark" mode="inline" items={items} 
                                onClick={handleMenuClick}
                                selectedKeys={[selectedPage]}
                            />
                        </Content>
                        <Footer className="account">
                            <Flex align="center" justify="space-between">
                            
                            {!collapsed ? (
                                <div className="descrip">
                                    <div>{user.profile.sub}</div>
                                    <small></small>
                                </div>
                            ) : null}
                            <Tooltip title={`${user.profile.sub} logout`} placement="right" >
                                {is(Role.ADMIN) && <StopServerButton />}
                                {!is(Role.ADMIN) && 
                                <Button type="text" className="logout"
                                    icon={<LogoutOutlined />}
                                    onClick={logout}
                                />}
                            </Tooltip>
                            </Flex>
                        </Footer>
                    </Layout>
                </Sider>
                <Content id="mainContent" style={{ position: "relative" }}>
                    {
                        is(Role.TECHNICIAN) &&  <>
                            <AgentPage />
                            <DomainPage />
                            <UserPage />
                        </> || <>
                            <AgentPage />
                        </>
                    }
                    {/* <DemoTagList /> */}
                    {/* <DemoPage /> */}
                    {/* <MatchPage /> */}
                </Content>
            </Layout>
        </MainContext.Provider>
    ) : null;
}
